/**
 * Browser wordings for a hashed asset a redeploy removed. Matched anywhere in the message: WebKit's MIME
 * phrasing opens with a quote, so TanStack's own prefix test misses it. Deliberately tight so an unrelated
 * TypeError never spends the reload.
 */
const STALE_CHUNK_SIGNATURES = [
	/failed to fetch dynamically imported module/i,
	/error loading dynamically imported module/i,
	/importing a module script failed/i,
	/is not a valid javascript mime type/i,
	/unable to preload css/i,
];

export function isStaleChunkError(error: unknown): boolean {
	let message = "";
	if (error instanceof Error) {
		message = error.message;
	} else if (typeof error === "string") {
		message = error;
	}
	return STALE_CHUNK_SIGNATURES.some((signature) => signature.test(message));
}
